import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import TimelineChart from '../Melillo/TimelineChart';
import { loadFormsAnalyticsData } from '../Melillo/actions';
import { withTranslation } from 'react-i18next';
import authUtils from '../../../auth/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartColumn } from '@fortawesome/free-solid-svg-icons';

class ChildDashboard extends Component {
	componentDidMount() {
		this.reloadData(this.props.childId);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.childId !== this.props.childId) {
			this.reloadData(nextProps.childId);
		}
	}

	reloadData(childId) {
		if (childId) {
			const { loadFormsAnalyticsData } = this.props;
			const requestData = { childId };

			loadFormsAnalyticsData('hemisphericAnalysis', { ...requestData, formName: 'KindyRooHemisphericAnalysis' });
			//loadFormsAnalyticsData('sensorAnalysis', requestData);		
		}
	}

	render() {
		const {
			currentUser,
			analytics: {
				hemisphericAnalysis,
				//sensorAnalysis				
			},
			t
		} = this.props;

		const canViewAnalytics = authUtils.hasPermission(currentUser, 'IndividualConsultationDocuments');

		return <div>{canViewAnalytics && <div>
			<Row>
				{/*
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesome name='bar-chart' />{t('ChildDashboard_SensorAnalysis')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...sensorAnalysis} name='SensorAnalysis'
								keys={['vestibularFunction', 'auditoryFunction', 'visualDysfunction', 'proprioceptiveFunction', 'hypotactileSymptom', 'hypertactileSymptom', 'hypersensitiveSmell', 'hyposensitiveSmell', 'total']} />
						</Panel.Body>
					</Panel>
				</Col>
				*/}
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('ChildDashboard_HemisphericAnalysis')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysis'
								keys={['right.total', 'left.total', 'rightAndLeft.total', 'rightToLeft']} />
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('ChildDashboard_HemisphericAnalysisRight')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisRight'
								keys={['right.motor', 'right.sensory', 'right.emotional', 'right.behavioral', 'right.academic', 'right.immune', 'right.autonomic']} />
						</Panel.Body>
					</Panel>
				</Col>

				<Col sm={12} md={12}>
					<Panel>
						<Panel.Heading><FontAwesomeIcon icon={faChartColumn} />{t('ChildDashboard_HemisphericAnalysisLeft')}</Panel.Heading>
						<Panel.Body>
							<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisLeft'
								keys={['left.motor', 'left.sensory', 'left.emotional', 'left.behavioral', 'left.academic', 'left.immune', 'left.autonomic']} />

						</Panel.Body>
					</Panel>
				</Col>
				<Row>
					<Col sm={12} md={12}>
						<Panel>
							<Panel.Heading><FontAwesomeIcon icon={faChartColumn} /> {t('ChildDashboard_HemisphericAnalysisRightAndLeft')}</Panel.Heading>
							<Panel.Body>
								<TimelineChart {...hemisphericAnalysis} name='HemisphericAnalysisRightAndLeft'
									keys={['rightAndLeft.motor', 'rightAndLeft.sensory', 'rightAndLeft.emotional', 'rightAndLeft.behavioral', 'rightAndLeft.academic', 'rightAndLeft.immune', 'rightAndLeft.autonomic']} />
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
			</Row>
			
		</div>}</div>;
	}
}

const mapStateToProps = (state) => {
	const {
		formsAnalytics: { melillo },
		auth: { currentUser }
	} = state;

	return {
		analytics: melillo,
		currentUser
	};
};

export default connect(mapStateToProps, {
	loadFormsAnalyticsData
})(withTranslation('formAnalytics.Melillo.resources')(ChildDashboard));